// ------------------------------------------------------------------
// CENTRALIZED BRAND-LINKS CONFIGURATION
// Update names, statuses, descriptions, URLs, and hotspot geometry
// for all six TEG brands here — the page adapts automatically.
// status: "active" opens `url` in a new tab.
// status: "coming_soon" opens the Coming Soon modal (no navigation).
// hotspot: percentages of the umbrella artwork (left/top/width/height).
// ------------------------------------------------------------------

export const ARTWORK_SRC = "/assets/teg-umbrella.png";

export const TAGLINE = "Building Wealth. Protecting Legacies. Creating Opportunity.";
export const TAGLINE_LINES = ["Building Wealth.", "Protecting Legacies.", "Creating Opportunity."];
export const CLOSING_STATEMENT = "One Umbrella. Multiple Brands. Endless Impact.";

export const BRAND_INTEREST_OPTIONS = [
    "Truth Excellence Group",
    "Truth Insurance",
    "The Truth Spot",
    "Truth Travels",
    "Truth Fleet",
    "Activate The Crowd",
    "Spit Your Truth",
];

export const BRANDS = [
    {
        id: "truth-insurance",
        name: "Truth Insurance",
        status: "active",
        url: "https://insurance.truthexcellencegroup.com",
        bookingUrl: "https://api.leadconnectorhq.com/widget/booking/QvGq6lr5RPTPBltutENs",
        eyebrow: "Life · Health · P&C",
        description: "Protect what matters most.",
        accent: "#D4AF37",
        logo: "/assets/logos/truth-insurance.png",
        logoShape: "circle",
        hotspot: { left: 6.8, top: 43, width: 15.6, height: 43 },
    },
    {
        id: "the-truth-spot",
        name: "The Truth Spot",
        status: "coming_soon",
        url: null,
        eyebrow: "Events · Culture · Community",
        description: "A home for truth. A stage for all.",
        accent: "#2E9BFF",
        logo: "/assets/logos/the-truth-spot.png",
        logoShape: "circle",
        hotspot: { left: 22.4, top: 43, width: 14.6, height: 43 },
    },
    {
        id: "truth-travels",
        name: "Truth Travels",
        status: "coming_soon",
        url: null,
        eyebrow: "Explore More",
        description: "Explore more. Experience more. Live more.",
        accent: "#E8B84B",
        logo: "/assets/logos/truth-travels.jpg",
        logoShape: "circle",
        hotspot: { left: 37.0, top: 43, width: 12.6, height: 43 },
    },
    {
        id: "truth-fleet",
        name: "Truth Fleet",
        status: "coming_soon",
        url: null,
        eyebrow: "Premium Vehicles · Flexible Rentals",
        description: "Premium vehicles. Flexible rentals. Elevated experiences.",
        accent: "#007AFF",
        logo: "/assets/logos/truth-fleet.png",
        logoShape: "circle",
        hotspot: { left: 49.6, top: 43, width: 14.0, height: 43 },
    },
    {
        id: "activate-the-crowd",
        name: "Activate The Crowd",
        status: "active",
        url: "https://ActivateTheCrowd.com",
        eyebrow: "Live Fan Experiences",
        description: "Voting. Engagement. Turn attention into action.",
        accent: "#8A63FF",
        logo: "/assets/logos/activate-the-crowd.webp",
        logoShape: "wide",
        hotspot: { left: 63.6, top: 43, width: 13.4, height: 43 },
    },
    {
        id: "spit-your-truth",
        name: "Spit Your Truth",
        status: "active",
        url: "https://SpitYourTruth.net",
        eyebrow: "Spoken Word · Est. 2015",
        description: "Real stories. Raw truth. Real impact.",
        accent: "#C7CEDA",
        logo: "/assets/logos/spit-your-truth.png",
        logoShape: "circle",
        hotspot: { left: 77.0, top: 43, width: 16.6, height: 43 },
    },
];
